import { useMemo } from "react"
import { FieldType, FieldValue, FormField, option, Option } from "../../../../features/ui"
import { TableName } from "../../../../tables"
import { Area, useEmployeeHooks, useEmployeeLoaders } from "../../../administration"
import { define } from "../../../../utils/typeUtils"

type Props = {
    defaultValue?: string,
    narrow?: boolean,
    active?: boolean
    onChange?: (value?: FieldValue) => void
}

export const SellerField = (props: Props): FormField => {
    const { defaultValue, narrow, active, onChange } = props
    
    const { describeEmployee } = useEmployeeHooks()

    const employeeLoaders = useEmployeeLoaders()

    const employees = useMemo(() => employeeLoaders().findAllEmployees(active).filter(employee =>
        [Area.MANAGMENT, Area.SALES].includes(employee.area) &&
        (!employee.archived || employee.id === defaultValue))
    , [])
    
    const options = employees.map(employee => option(employee.id, describeEmployee(employee)))
    
    const renderOption = async (
        option: Option,
        onClick?: (e: React.MouseEvent<HTMLElement>
    ) => void) => {
        const seller = define(employees.find(employee => employee.id === option.value))
        return (
            <div onClick={onClick}>
                <span>{describeEmployee(seller)}</span>
            </div>
        )
    }

    return {
        name: 'sellerId',
        type: FieldType.TABLE,
        table: TableName.EMPLOYEES,
        label: 'Vendedor',
        defaultValue,
        options,
        placeholder: 'Buscar por nombre o DNI',
        narrow,
        renderOption,
        onChange
    }
}
